import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "row"]

  add() {
    const template = `
      <div class="grid grid-cols-12 gap-3 items-end" data-line-items-target="row">
        <div class="col-span-4">
          <label class="block text-xs font-medium text-mod-text-muted">Item</label>
          <input type="text" name="line_items[][name]" class="mt-1 block w-full rounded-lg border-mod-border shadow-sm focus:border-mod-charcoal-soft focus:ring-mod-charcoal-soft text-sm">
        </div>
        <div class="col-span-3">
          <label class="block text-xs font-medium text-mod-text-muted">Description</label>
          <input type="text" name="line_items[][description]" class="mt-1 block w-full rounded-lg border-mod-border shadow-sm focus:border-mod-charcoal-soft focus:ring-mod-charcoal-soft text-sm">
        </div>
        <div class="col-span-2">
          <label class="block text-xs font-medium text-mod-text-muted">Qty</label>
          <input type="number" name="line_items[][quantity]" min="1" value="1" class="mt-1 block w-full rounded-lg border-mod-border shadow-sm focus:border-mod-charcoal-soft focus:ring-mod-charcoal-soft text-sm">
        </div>
        <div class="col-span-2">
          <label class="block text-xs font-medium text-mod-text-muted">Price</label>
          <input type="number" name="line_items[][unit_price]" step="0.01" min="0" class="mt-1 block w-full rounded-lg border-mod-border shadow-sm focus:border-mod-charcoal-soft focus:ring-mod-charcoal-soft text-sm">
        </div>
        <div class="col-span-1">
          <button type="button" data-action="line-items#remove" class="text-red-500 hover:text-red-700 p-2">✕</button>
        </div>
      </div>
    `
    this.containerTarget.insertAdjacentHTML("beforeend", template)
  }

  remove(event) {
    event.target.closest("[data-line-items-target='row']").remove()
  }
}
